export const createSelectOptions = <T>(obj: {
  [key: string]: T
}): { value: string; label: T }[] => {
  return Object.keys(obj).map((key) => ({ value: key, label: obj[key] }))
}
